const debug = console.log; //new (debugModule as any)('getMaterial');
var controller = null;
export function getAllMaterials(API, order) {
    //todo order and any class
    if (!order)
        throw new Error("getAllMaterials requires order");
    if (controller) {
        controller.abort();
        controller = null;
    }
    controller = new AbortController();
    let contour = order.drawing.calcContour();
    let MatOptions = {
        qty: order.qty,
        Width: contour.width,
        Height: contour.height,
        Pierces: order.cuts,
        CutDistance: order.cuttingLength,
        Folds: order.bends ? order.bends.length : 0,
        Material: "",
        Thickness: "",
    };
    return API.jsonFetch("meterials/list", MatOptions, controller).then((r) => {
        controller = null;
        if (r && r.data)
            return r.data.Materials;
        return null;
    });
}
export function getMaterial(API, order) {
    if (controller) {
        controller.abort();
        controller = null;
    }
    if (!order.drawing)
        return false;
    controller = new AbortController();
    let contour = order.drawing.calcContour();
    let Material = order.selMaterial ? order.selMaterial.Material : "";
    let Thickness = order.selMaterial ? order.selMaterial.Thickness : "";
    let MatOptions = {
        qty: order.qty,
        Width: contour.width,
        Height: contour.height,
        Pierces: order.cuts,
        CutDistance: order.cuttingLength,
        Folds: order.bends ? order.bends.length : 0,
        Material: Material,
        Thickness: Thickness,
    };
    return API.jsonFetch("meterials/list", MatOptions, controller).then((r) => {
        controller = null;
        if (Material) {
            if (r && r.data)
                if (r && r.data.Qty == order.qty && r.data.Materials)
                    return r.data;
            console.error("Failed to update Materials", order, r);
            return null;
        }
        if (r && r.data)
            return r.data;
        return null;
    });
}
